import React, {useEffect, useRef, useState} from 'react';
import styles from './index.module.less';
import {Button, Callout, Card, Classes, Collapse, Icon, Intent} from "@blueprintjs/core";
import Markdown from "../Markdown";
import emitter from "../../utils/emitter";
import classes from 'classnames';

const CodingQuestion = ({ exercise, lessonId }) => {
  const [tipsOpen, setTipsOpen] = useState(false);
  const [codeOpen, setCodeOpen] = useState(false);
  const codeBlock = useRef(null);
  const container = useRef(null);
  const expectCodeContainer = useRef(null);
  const expectCodeInitialized = useRef(false);
  useEffect(() => {
    if (container.current === null) {
      return;
    }
    const runner = container.current.querySelector('.code-block-runner-trigger');
    if (runner) {
      runner.style.display = 'none';
    }
  }, []);
  useEffect(() => {
    expectCodeInitialized.current = false;
    setCodeOpen(false);
  }, [lessonId]);
  useEffect(() => {
    if (expectCodeInitialized.current === true) {
      return;
    }
    if (exercise.showErrorCode === true) {
      expectCodeInitialized.current = true;
      expectCodeContainer.current.scrollIntoViewIfNeeded(false);
    }
  }, [exercise.showErrorCode]);
  useEffect(() => {
    if (codeOpen === true && codeBlock.current) {
      setTimeout(() => {
        window.hljs.highlightBlock(codeBlock.current);
      }, 100);
    }
  }, [codeOpen]);
  const handleCopyCodeToEditor = () => {
    emitter.emit('copy-question-code', {
      code: exercise.code,
      defaultCode: exercise.defaultCode,
      id: exercise.id,
      title: exercise.title,
      status: exercise.status
    });
  };
  return (
    <div className={styles['coding-question']} ref={container}>
      <Card>
        <div className={styles.header}>
          <h5 className={Classes.HEADING}>
            <Icon icon='console' />
            <span style={{ display: 'inline-block', paddingLeft: 8.0 }}>
              编程题：{exercise.title}
            </span>
          </h5>
          <div className={classes(styles.action, 'exercise-action')}>
            {exercise.status === 'undo' && (
              <Button small intent={Intent.WARNING} icon='code' onClick={handleCopyCodeToEditor}>未完成：开始做题</Button>
            )}
            {exercise.status === 'right' && (
              <Button small intent={Intent.SUCCESS} icon='code' onClick={handleCopyCodeToEditor}>答案正确，点击重做</Button>
            )}
            {exercise.status === 'wrong' && (
              <Button small intent={Intent.DANGER} icon='code' onClick={handleCopyCodeToEditor}>答案错误，继续做题</Button>
            )}
            {exercise.status === 'doing' && (
              <Button small disabled icon='code'>正在答题中...</Button>
            )}
          </div>
        </div>
        <Markdown content={exercise.desc} />
      </Card>
      {exercise.showErrorCode === true && (
        <div ref={expectCodeContainer}>
          <Callout className={styles['tips-container']}>
            <div className={styles['tips-title']}>
              <h5 className={Classes.HEADING}>查看正确答案</h5>
              <Button icon={codeOpen ? 'chevron-up' : 'chevron-down'} small onClick={() => setCodeOpen(!codeOpen)} />
            </div>
            <Collapse isOpen={codeOpen}>
              <pre ref={codeBlock} className={classes(styles.answer, 'bp3-code-block', 'bp3-text-large')}>
                <code className='python'>{exercise.expectCode}</code>
              </pre>
            </Collapse>
          </Callout>
        </div>
      )}
      {exercise.tips && (
        <Callout className={styles['tips-container']}>
          <div className={styles['tips-title']}>
            <h5 className={Classes.HEADING}>题目解法参考</h5>
            <Button icon={tipsOpen ? 'chevron-up' : 'chevron-down'} small onClick={() => setTipsOpen(!tipsOpen)} />
          </div>
          <Collapse isOpen={tipsOpen} keepChildrenMounted>
            {exercise.tips}
          </Collapse>
        </Callout>
      )}
    </div>
  );
};

export default CodingQuestion;
